/**
 * QuickStartWrapper Component
 * Wrapper for Quick Start Templates modal
 */

import React from 'react';
import { QuickStartTemplates } from '../quickstart';

export const QuickStartWrapper = ({
  isOpen,
  onClose,
  onSelectTemplate,
}) => {
  return (
    <QuickStartTemplates
      isOpen={isOpen}
      onClose={onClose}
      onSelectTemplate={onSelectTemplate}
    />
  );
};

export default QuickStartWrapper;
